<template>
    <div id="local">
        <SOSlotBase
            :container-name="`landing-page-komplain-qris`"
            bg-grey
            :is-search="searchState.isSearch"
            :loading="pageSetting.isLoading"
        >
            <template v-slot:loading-page>
                <SOLoadingPage />
            </template>
            <template v-slot:title-bar>
                <SOTitleBar
                    page-title="Penanganan QRIS Gagal"
                    type="back"
                    @back="back"
                    show-search
                    @search="toggleSearch(true)"
                    v-if="!searchState.isSearch"
                />
            </template>
            <template v-slot:search-bar>
                <SOSearchBar
                    v-if="searchState.isSearch"
                    context="Biaya Workshop"
                    search-information="Nama konsumen, no telp, nama mesin & nama outlet"
                    @return-search-value="v => searchState.term = v"
                    @close="toggleSearch(false)"
                    :value="searchState.term"
                    :data-count="listKomplain.count_data"
                    @loading="v => searchState.typing = v"
                    :waiting="searchState.typing"
                    @do-search="getData()"
                />
            </template>
            <template v-slot:content>
                <div class="p-x-20">
                    <div class="p-t-16 md:p-t-10">
                        <SOHeaderList
                            :title="listKomplain.count_data + ' Komplain'"
                            show-filter
                            @filter="pageSetting.showFilter = true"
                        />
                    </div>
                    <template v-if="listKomplain.count_data">
                        <ListCard
                            v-for="(item, index) in listKomplain.actual_data"
                            :key="index"
                            :data="item"
                        />
                        <SOLoadMoreLoading
                            v-if="listKomplain.actual_data.length < listKomplain.count_data"
                            id="load-more-list-komplain"
                            loading
                            @intersect="!pageSetting.isLoadingMore && loadMoreData()"
                        />
                    </template>
                </div>
            </template>
            <template v-slot:empty-state v-if="!listKomplain.actual_data.length">
                <SOEmptyState
                    v-if="!searchState.isSearch"
                    message="Belum ada komplain Qris"
                />
                <template v-else>
                    <SOEmptySearchState
                        v-if="searchState.term.length > 2 && !searchState.typing"
                        @action="
                            () => {
                                resetFilter();
                                searchState.term = '';
                            }
                        "
                    />
                </template>
            </template>
            <template v-slot:filter>
                <FilterKomplainQris
                    v-model="pageSetting.showFilter"
                    @do-filter="query => doFilter(query)"
                />
            </template>
        </SOSlotBase>
    </div>
</template>
<script>

import { mapGetters, mapActions, mapMutations } from "vuex";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOHeaderList from "@/so-components/global/ui/SOHeaderList";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState";
import SOSearchBar from "@/so-components/global/ui/SOSearchBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading";
import ListCard from '../components/ListCard.vue';
import FilterKomplainQris from '../components/FilterKomplainQris.vue';

export default {
    name: "KomplainQrisList",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOHeaderList,
        SOEmptyState,
        SOEmptySearchState,
        SOSearchBar,
        SOLoadingPage,
        SOLoadMoreLoading,
        ListCard,
        FilterKomplainQris,
    },
    beforeRouteEnter(to, from, next) {
        next(vm => { 
            if (from.name !== 'komplainQris.detail') {
                vm.getData();
            }
            else {
                if (vm.needReload) {
                    vm.getData();
                }
                else {
                    vm.scrollTo();
                }
            }
        }) 
    },
    data() {
        return {
            isSearch: false,
            pageSetting: {
                isLoading: false,
                isLoadingMore: false,
                showFilter: false,
                useFilter: false
            },
            searchState: {
                typing: false,
                isSearch: false,
                term: '',
            },
            query: {},
        };
    },
    computed: {
        ...mapGetters(moduleName, {
            listKomplain: "listKomplain",
            scrollState: "scrollState",
            needReload: "needReload",
        }),
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem",
            filter: "getFilter"
		}),
    },
    methods: {
        ...mapActions({
            getListKomplain: `${moduleName}/getListKomplain`
        }),
        ...mapMutations({
            resetListKomplain: `${moduleName}/resetListKomplain`,
            resetScrollState: `${moduleName}/resetScrollState`,
        }),
        resetFilter() {
            this.$store.commit("filterGlobalModule/resetFilterItem");
            this.$store.commit("filterGlobalModule/resetFilter");
            this.$store.commit("filterGlobalModule/setFilter", {"sortBy":"1","orderBy":"ASC"})
            this.resetScrollState();
        },
        scrollTo() {
            setTimeout(() => {
                document.documentElement.scrollTop = document.body.scrollTop = this.scrollState;
            }, 100);
        },
        defaultQuery() {
            return {
                limit: 20,
                offset: 0,
                sort: this.filter.sortBy,
                order: this.filter.orderBy,
                filter_by: this.filterItem.periode.filterBy,
                status: this.filterItem.statusKomplain,
                idoutlet: this.filterItem.outlet,
                tanggal_awal: this.filterItem.periode.startDate,
                tanggal_akhir: this.filterItem.periode.endDate,
                bulan: this.filterItem.periode.month,
                tahun: this.filterItem.periode.year,
            }
        },
        async getData() {
            this.pageSetting.isLoading = this.searchState.term != '' ? false : true
            this.resetFilter();
            this.query = {
                ...this.defaultQuery(),
                ...(this.searchState.term && {key: this.searchState.term})
            }
            this.pageSetting.useFilter = false
            await this.getListKomplain(this.query);
            this.searchState.typing = false
            this.pageSetting.isLoading = false
        },
        async loadMoreData() {
            this.pageSetting.isLoadingMore = true
            this.query.offset = this.listKomplain.actual_data.length
            await this.getListKomplain(this.query);
            this.pageSetting.isLoadingMore = false
        },
        async doFilter(){
            this.pageSetting.isLoading = true
            this.pageSetting.useFilter = true
            this.query = {
                ...this.defaultQuery(),
                ...(this.searchState.term && {key: this.searchState.term})
            }
            await this.getListKomplain(this.query);
            this.pageSetting.isLoading = false
        },
        back() {
            this.$router.push("/dashboard");
        },
        toggleSearch(v) {
            this.searchState = {
                typing: false,
                isSearch: v,
                term: ''
            }
            if (!v) this.getData()
            this.resetListKomplain();
        },
    },
    watch: {
        'searchState.term': function(val) {
            if (!val) {
                this.resetListKomplain();
            }
        }
    }
};
</script>

<style scoped>
.local .separator {
    width: unset;
}
.grey-bg {
    background: linear-gradient(90deg, #EDEDED 0%, #FFFFFF 100%);
}
</style>
